import {MaterializationDetails} from "./materialization-details";

export class ResultDetails {

  constructor(
    public resultId: number,
    public matCount: number,
    public translatorCount: number,
    public highlightCount: number,
    public matDetails: MaterializationDetails[]
  ){

  }
}
